import axios from 'axios';
import { reportError } from '../utils/reportError';

function extractMessage(data, fallback) {
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object') {
        if (typeof data.message === 'string' && data.message.trim()) return data.message;
        if (typeof data.error === 'string' && data.error.trim()) return data.error;
    }
    return fallback;
}

export function handleAxiosError(error, navigate) {
    if (axios.isAxiosError(error)) {
        if (error.response) {
            const { status, data, statusText } = error.response;
            // 401 = не авторизований (немає/протух токен) — єдиний випадок, коли варто
            // редіректити на логін. 403 та інші статуси — бізнес-помилка (ліміт тарифу,
            // заблокований клієнт, недостатньо прав тощо), її треба показати користувачу,
            // а не вибивати з сесії.
            if (status === 401) {
                console.error('Auth error 401: Redirecting to login.');
                navigate('/login');
                return { error: 'Unauthorized: Redirecting to login.', status };
            }
            const message = extractMessage(data, `Request failed with status ${status}: ${statusText}`);
            console.error(`Request failed with status ${status}: ${message}`);
            return { error: message, status };
        } else {
            console.error("Network error: No response from server.");
            return { error: "Network error: Please check your connection and try again." };
        }
    } else {
        // Not an axios error = a bug in the request/response code, not an HTTP failure.
        reportError(error, { where: 'handleAxiosError' });
        return { error: "An unexpected error occurred. Please try again later." };
    }
}